export const RdarrRoutingUrls = {
    base: '/',
    rdarrReimagined: '/Dashboard',
    evidenceBasedApproach: '/Dashboard/Evidence',
    dataQuality: '/Dashboard/DataQuality',
    riskAndFinanceAlignment: '/Dashboard/RiskAndFinance',
    sarbSelfAssessment: '/Dashboard/SelfAssessment',
};
